import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    attrs: {
      headers: _vm.tabela.headers,
      items: _vm.perfis,
      search: _vm.tabela.opcoes.pesquisa,
      "sort-by": _vm.tabela.opcoes.ordenarPor,
      "sort-desc": _vm.tabela.opcoes.decrescente,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function () {
            return [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-sort", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VSpacer),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-search", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: `item.numero`,
          fn: function ({ index }) {
            return [_c("span", [_vm._v(_vm._s(index + 1))])]
          },
        },
        _vm._l(_vm.relatorio.deficiencias, function (deficiencia) {
          return {
            key: `item.${_vm.normalizarTexto(deficiencia.nome)}`,
            fn: function ({ item }) {
              return [
                item.isDeficiente === null
                  ? _c(
                      VIcon,
                      { key: deficiencia.nome, attrs: { color: "grey" } },
                      [_vm._v(" quiz ")]
                    )
                  : _c(
                      VIcon,
                      {
                        key: deficiencia.nome,
                        attrs: {
                          color:
                            item[`${_vm.normalizarTexto(deficiencia.nome)}`] > 0
                              ? "secondary"
                              : "grey",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getCheckBoxIcon(
                                item[
                                  `${_vm.normalizarTexto(deficiencia.nome)}`
                                ] > 0
                              )
                            ) +
                            " "
                        ),
                      ]
                    ),
              ]
            },
          }
        }),
        {
          key: `body.append`,
          fn: function ({ headers }) {
            return [
              _c("tr", [
                _c(
                  "td",
                  { attrs: { colspan: headers.length } },
                  [
                    _c(
                      VRow,
                      {
                        staticClass: "justify-center mb-2",
                        attrs: { dense: "" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "caption grey--text text--darken-2 mr-8",
                          },
                          [_vm._v("LEGENDA")]
                        ),
                        _c(
                          VIcon,
                          { staticClass: "mr-1", attrs: { color: "grey" } },
                          [_vm._v("quiz")]
                        ),
                        _vm._v(" Não Respondeu "),
                        _c(
                          VIcon,
                          {
                            staticClass: "ml-8 mr-1",
                            attrs: { color: "grey" },
                          },
                          [_vm._v("check_box_outline_blank")]
                        ),
                        _vm._v(" Não "),
                        _c(
                          VIcon,
                          {
                            staticClass: "ml-8 mr-1",
                            attrs: { color: "secondary" },
                          },
                          [_vm._v("check_box")]
                        ),
                        _vm._v(" Sim "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }